module.exports = __webpack_public_path__ + "img/vrart_balloon2_sp.fca91d70.svg";